import React, { useEffect, useRef } from "react";
import { chartDarkTheme, chartLightTheme } from "@/app/theme/theme";
import * as echarts from "echarts";

interface EChartsBaseProps {
  option: any;
  theme?: string;
  style?: React.CSSProperties;
}

const EChartsBase: React.FC<EChartsBaseProps> = ({ option, theme = "light", style }) => {
  const chartRef = useRef<HTMLDivElement>(null);
  const chartInstance = useRef<echarts.EChartsType | null>(null);

  // 只在 theme 或首次挂载时 init/dispose
  useEffect(() => {
    echarts.registerTheme("light", chartLightTheme);
    echarts.registerTheme("dark", chartDarkTheme);
    if (!chartRef.current) return;
    if (chartInstance.current) {
      chartInstance.current.dispose();
    }
    chartInstance.current = echarts.init(chartRef.current, theme);

    const handleResize = () => {
      chartInstance.current && chartInstance.current.resize();
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      chartInstance.current && chartInstance.current.dispose();
      chartInstance.current = null;
    };
  }, [theme]);

  // 只有 option 变化时 setOption，不重新 init
  useEffect(() => {
    if (chartInstance.current && option) {
      chartInstance.current.setOption(option, true);
    }
  }, [option]);

  return <div ref={chartRef} style={style} />;
};

export default EChartsBase;
